import { render, staticRenderFns } from "./SbInspectModal.vue?vue&type=template&id=1d59c8d4"
import script from "./SbInspectModal.vue?vue&type=script&lang=js"
export * from "./SbInspectModal.vue?vue&type=script&lang=js"
import style0 from "./SbInspectModal.vue?vue&type=style&index=0&id=1d59c8d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports